"use client";

import { useNavigate, useParams, useLocation } from "react-router-dom";
import styles from "../css/consultation-history-sidebar.module.css";
import {
  FileText,
  Heart,
  Stethoscope,
  Syringe,
} from "lucide-react";

const HISTORY_MENU_ITEMS = [
  { id: "services-done", icon: <FileText size={18} />, text: "Services Done" },
  { id: "medical-history", icon: <Heart size={18} />, text: "Medical History" },
  { id: "treatment-history", icon: <Stethoscope size={18} />, text: "Treatment History" },
  { id: "immunizations", icon: <Syringe size={18} />, text: "Immunizations" },
];

export default function ConsultationHistorySidebar() {
  const navigate = useNavigate();
  const { id } = useParams();
  const location = useLocation();

  const getPatientId = () => {
    const raw = id || "";
    if (raw && raw !== "undefined" && raw !== "null") return raw;
    const m = String(location?.pathname || "").match(/\/consultation-history\/([^/]+)/);
    const fromPath = m?.[1] || "";
    if (fromPath && fromPath !== "undefined" && fromPath !== "null") return fromPath;
    return "";
  };

  const getActiveItem = () => {
    const path = location.pathname;
    if (path.includes("/services-done")) return "services-done";
    if (path.includes("/medical-history")) return "medical-history";
    if (path.includes("/treatment-history")) return "treatment-history";
    if (path.includes("/immunizations")) return "immunizations";
    return "services-done";
  };

  const activeItem = getActiveItem();

  const handleItemClick = (itemId) => {
    const patientId = getPatientId();
    if (!patientId) {
      navigate("/customer/clinic/consultation-history");
      return;
    }
    switch (itemId) {
      case "services-done":
        navigate(`/customer/clinic/consultation-history/${patientId}/services-done`);
        break;
      case "medical-history":
        navigate(`/customer/clinic/consultation-history/${patientId}/medical-history`);
        break;
      case "treatment-history":
        navigate(`/customer/clinic/consultation-history/${patientId}/treatment-history`);
        break;
      case "immunizations":
        navigate(`/customer/clinic/consultation-history/${patientId}/immunizations`);
        break;
      default:
        console.log("Invalid menu item:", itemId);
    }
  };

  return (
    <nav className={styles.sidebar}>
      {/* <div className={styles.sidebarHeader}>
        <div className={styles.headerIcon}>
          <FileText size={24} />
        </div>
        <h3 className={styles.title}>Services Done</h3>
      </div> */}

      <div className={styles.sidebarContent}>
        <ul className={styles.menuList}>
          {HISTORY_MENU_ITEMS.map((item) => {
            const isActive = activeItem === item.id;

            return (
              <li
                key={item.id}
                className={`${styles.menuItem} ${isActive ? styles.active : ""}`}
                onClick={() => handleItemClick(item.id)}
              >
                <div className={styles.menuIcon}>{item.icon}</div>
                <span className={styles.menuText}>{item.text}</span>
              </li>
            );
          })}
        </ul>
      </div>
    </nav>
  );
}
